import { useEffect, useState } from "react";
import { getAllOrderList } from "../../services/OrderService";
import { useSelector } from "react-redux";

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = useSelector((state) => state.auth.userId); 
  useEffect(() => {
    if (userId) {
    const fetchOrders = async () => {
      try {
        const orders = await getAllOrderList(userId);
        setOrders(orders);
        console.log("orders",orders)
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }
  }, [userId]);
  console.log("ordersssss",orders)
  
  const getDeliveryDate = (createdDate) => {
    if (!createdDate) return "N/A";
    const date = new Date(createdDate);
    date.setDate(date.getDate() + 5);
  
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };
  
  return (
    <>
      <div className="mb-4">
        <div className="col-md-7 heading-section">
          <span className="subheading">Orders</span>
        </div>

        {loading ? (
          <p className="text-white">Loading orders ....</p>
        ) : orders.length > 0 ? (
          <>
            <div>
              <p className="text-white mt-3"> Total Count : {orders.length}</p>

            </div>
            {orders.map((order,index) => (
              <div key={order?.guid}className="row justify-content-center mt-5 bg-color p-3">
                   {order?.orderItemsList.map((item,index) => (
                    <>
                <div className="col-lg-3 wow fadeIn" data-wow-delay="0.1s">
                <img
  src={`https://inventory-api.exodusvacations.in/${item.thumbimage?.trim().replace(/^wwwroot\//, "")}`}
  alt={item.name}
  width={150}
  height={150}
  className="img-fluid"
/>
                </div>
                <div className="col-lg-9 wow fadeIn text-white text-left" data-wow-delay="0.5s">
                  <div className="section-title">
                    <h5 className="display-7 text-uppercase mt-2">{item?.description}</h5>
                  </div>
                  {/* <p className="p-color">{order.orderStatus}</p> */}
                  <p className=""><span>{item?.subTotal}</span></p>
                  <p className="p-color m-0">Order Id: {item?.prodGuId}</p>
                  {/* <p className="p-color">Expected delivery date: 12/12/2025</p> */}
                  <p className="p-color">Expected delivery date: {getDeliveryDate(order.createdDate)}</p>
                </div>
               
                  </>
                   ))}
                    <br/>
              </div>
              
            ))}
          </>
        ) : (
          <div className=" py-5">
            <h3 className="text-white">No Orders Found</h3>
            <p className="text-light">Your order history will appear here.</p>
          </div>
        )}
      </div>
    </>
  )
}
export default OrderList;